import Vue from 'vue';

Vue.component('stock-check-index', () =>
    import(/* webpackChunkName: 'stock-check-index' */ './stock-check-index.vue'),
);
